import { createContext } from 'react';

import type { IWithdrawRequestContext } from '../DialogWithdrawRequest.helpers';

export const WithdrawRequestContext = createContext<IWithdrawRequestContext | null>(null);
